import React, { JSXElementConstructor, ReactElement } from 'react';

import {
  Drawer,
  Modal, 
} from "@mui/material";
import { makeStyles } from "@utilities/theme_utilities";

interface Props {
  children: ReactElement<any, string | JSXElementConstructor<any>> | null | undefined | false;
  open: boolean;
  // drawer_only?: boolean;
  full_page?: boolean;
  onClose: () => void;
  width?: number | string;
}

export default function ModalOrDrawer({ 
  children,
  open, 
  full_page = false,
  // drawer_only = false,
  onClose,
  width: param_width
}: Props) {
  
  const useStyles = makeStyles()((theme) => {
    return ({
      root: {
        // color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.mode === "dark" ? "black" : "white",
      },
    });
  });

  const { classes, cx } = useStyles();

  const wide_mode = window.innerWidth >= 600;

  if (wide_mode) { // && !drawer_only) {
    const width = param_width ? param_width : (full_page ? "90%" : "522px");
    return (
      <Modal
        open={open}
        onClose={onClose}>
        <div className={cx(classes.root, "paper modal_main")} 
          style={ full_page ? { height: window.innerHeight - 34, width, overflowY: "auto" } : { maxHeight: window.innerHeight - 34, width, overflowY: "auto" }}>
          { children }
        </div>
      </Modal>
    );
  } else {
    return (
      <Drawer anchor="right" 
        open={open}
        onClose={onClose}>
        <div className={cx(classes.root, "drawer")}>
          { children }
        </div>
      </Drawer>
    );
  }
}
